import {Injectable, ComponentRef} from '@angular/core';
import {ActivatedRouteSnapshot, DetachedRouteHandle} from '@angular/router';
import {Location} from '@angular/common';
import {DwTabRouteReuseService} from '@webdpt/framework';


@Injectable()
export class FxTabRouteReuseService extends DwTabRouteReuseService {

  constructor(location: Location) {
    super(location);
  }

  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    let flag = true;
    if (future.params.hasOwnProperty('routeKey') && curr.params.hasOwnProperty('routeKey')) {
      flag = future.params.routeKey === curr.params.routeKey;
    }
    // if (future.routeConfig && future.routeConfig.path === 'shopping-cart') {
    //   return false;
    // }
    // if ((future as any)._urlSegment.segments.map(seg => (seg.path)).join('/') === 'mall/shopping-cart') {
    //   return false;
    // }
    if (future.routeConfig && future.routeConfig.data && future.routeConfig.data.reload) {
      return false;
    }
    return (future.routeConfig === curr.routeConfig) && flag;
  }
}
